import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LandingDemo } from "@/pages/home/LandingDemo";
import { LandingMoreLink } from "@/pages/home/LandingMoreLink";
import { LANDING_HERO, LANDING_ROUTES } from "@/pages/home/landingContent";

/**
 * Hero de la landing: texto + demo en dos columnas (desktop) o apilados (mobile).
 * Título 32 → 50 px: excepción al tamaño máximo del design system (36 px)
 * pedida por Victoria para la home pública (TALAPP-1916).
 */
export function LandingHero() {
  return (
    <section
      aria-labelledby="landing-hero-title"
      className="relative mx-auto flex w-full max-w-7xl min-h-0 flex-1 flex-col px-4 md:grid md:grid-cols-2 md:items-center md:gap-16 md:px-8"
    >
      <div className="flex flex-col pt-2 md:pt-0 md:pb-6">
        <h1
          id="landing-hero-title"
          className="text-balance text-[clamp(32px,3.6vw,50px)] font-bold leading-[1.1] tracking-tight"
        >
          {LANDING_HERO.title}
        </h1>
        <p className="mt-4 max-w-[46ch] text-[15px] leading-relaxed text-white/90 md:mt-6 md:text-lg">
          {LANDING_HERO.subtitle}
        </p>
        <div className="mt-6 flex flex-col md:mt-9 md:items-start">
          <Button
            asChild
            size="lg"
            className="h-12 w-full bg-card px-6 text-base font-bold text-[var(--ava-primary-600)] hover:bg-[var(--ava-primary-50)] focus-visible:ring-white/70 md:w-auto md:min-w-60"
          >
            <Link href={LANDING_ROUTES.register}>
              {LANDING_HERO.cta}
              <ArrowRight aria-hidden="true" />
            </Link>
          </Button>
          <p className="mt-1 flex flex-wrap items-center justify-center gap-x-1 text-sm text-white/90 md:justify-start">
            {LANDING_HERO.loginPrompt}
            <Link
              href={LANDING_ROUTES.login}
              className="inline-flex min-h-11 items-center rounded-sm px-1 font-semibold text-white underline underline-offset-3 outline-none focus-visible:ring-2 focus-visible:ring-white"
            >
              {LANDING_HERO.loginLabel}
            </Link>
          </p>
        </div>
        <LandingMoreLink className="justify-center md:hidden" />
      </div>
      <LandingDemo />
    </section>
  );
}
